import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FaqComponent } from './faq/faq.component';
import { FaqsListComponent } from './faqs-list/faqs-list.component';
import { CommonModule } from '@angular/common';
import { FileDownloadComponent } from './file-download/file-download.component';
import { EntryStatusComponent } from './entry-status/entry-status.component';
import { SequenceCardComponent } from './sequence-card/sequence-card.component';
import { StatusMessageComponent } from './status-message/status-message.component';
import { NotificationMsgComponent } from './notification-msg/notification-msg.component';
import { NgMaterialModule } from './ngmaterial.module';
import { HelpIconWithTooltipComponent } from './help-icon-with-tooltip/help-icon-with-tooltip.component';
import { EntryDropdownComponent } from './entry/entry-dropdown/entry-dropdown.component';

const declarations = [FaqComponent, FaqsListComponent, FileDownloadComponent, EntryStatusComponent, StatusMessageComponent, 
  SequenceCardComponent, NotificationMsgComponent, 
      HelpIconWithTooltipComponent, EntryDropdownComponent];

@NgModule({
  declarations: [...declarations],
  exports: [...declarations, NgMaterialModule],
  imports: [CommonModule, NgMaterialModule],
})
export class SharedModule {}
